import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enLocale from './assets/locales/en/translation.json';
import esLocale from './assets/locales/es/translation.json';
import ptLocale from './assets/locales/pt/translation.json';
import bgLocale from './assets/locales/bg/translation.json';
import itLocale from './assets/locales/it/translation.json';
import frLocale from './assets/locales/fr/translation.json';
import deLocale from './assets/locales/de/translation.json';
import trLocale from './assets/locales/tr/translation.json';
import hiLocale from './assets/locales/hi/translation.json';

i18n.use(
    new LanguageDetector(null, {
        caches: [],
    }),
)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        resources: {
            en: { translation: enLocale },
            es: { translation: esLocale },
            pt: { translation: ptLocale },
            bg: { translation: bgLocale },
            it: { translation: itLocale },
            fr: { translation: frLocale },
            de: { translation: deLocale },
            tr: { translation: trLocale },
            hi: { translation: hiLocale },
        },
    });

export default i18n;
